import { tokens } from "src/locales/tokens";

export const zh = {
  [tokens.common.languageChanged]: "语言已更改",
  [tokens.nav.academy]: "学院",
  [tokens.nav.account]: "账户",
  [tokens.nav.analytics]: "分析",
  [tokens.nav.auth]: "认证",
  [tokens.nav.blog]: "博客",
  [tokens.nav.browse]: "浏览",
  [tokens.nav.calendar]: "日历",
  [tokens.nav.changelog]: "更新日志",
  [tokens.nav.chat]: "聊天",
  [tokens.nav.checkout]: "结账",
  [tokens.nav.concepts]: "概念",
  [tokens.nav.contact]: "联系",
  [tokens.nav.course]: "课程",
  [tokens.nav.create]: "创建",
  [tokens.nav.crypto]: "加密货币",
  [tokens.nav.customers]: "客户",
  [tokens.nav.dashboard]: "仪表盘",
  [tokens.nav.details]: "详情",
  [tokens.nav.documentation]: "文档",
  [tokens.nav.ecommerce]: "电子商务",
  [tokens.nav.edit]: "编辑",
  [tokens.nav.error]: "错误",
  [tokens.nav.feed]: "动态",
  [tokens.nav.fileManager]: "文件管理器",
  [tokens.nav.finance]: "财务",
  [tokens.nav.fleet]: "车队",
  [tokens.nav.forgotPassword]: "忘记密码",
  [tokens.nav.invoiceList]: "发票",
  [tokens.nav.jobList]: "职位列表",
  [tokens.nav.kanban]: "看板",
  [tokens.nav.list]: "列表",
  [tokens.nav.login]: "登录",
  [tokens.nav.logistics]: "物流",
  [tokens.nav.mail]: "邮件",
  [tokens.nav.management]: "管理",
  [tokens.nav.orderList]: "订单",
  [tokens.nav.overview]: "概览",
  [tokens.nav.pages]: "页面",
  [tokens.nav.postCreate]: "创建文章",
  [tokens.nav.postDetails]: "文章详情",
  [tokens.nav.postList]: "文章列表",
  [tokens.nav.pricing]: "定价",
  [tokens.nav.productList]: "产品",
  [tokens.nav.profile]: "个人资料",
  [tokens.nav.register]: "注册",
  [tokens.nav.roadmap]: "路线图",
  [tokens.nav.resetPassword]: "重置密码",
  [tokens.nav.socialMedia]: "社交媒体",
  [tokens.nav.verifyCode]: "验证代码",
  [tokens.nav.catalog]: "目录",
};
